import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CreateSparkCampaign } from '../../../../service/create-spark-campaign/create-spark-campaign';

@Component({
  selector: 'cad-group-placements',
  imports: [ReactiveFormsModule],
  templateUrl: './group-placements.html',
  styleUrl: './group-placements.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupPlacements {
  expanded = signal<boolean>(true);

  private createSparkCampaignService = inject(CreateSparkCampaign);

  /** Checked when comments are allowed (`comment_disabled` is false). */
  readonly commentsAllowedControl = new FormControl<boolean>(false, { nonNullable: true });

  /** Checked when video download is allowed (`video_download_disabled` is false). */
  readonly videoDownloadAllowedControl = new FormControl<boolean>(false, { nonNullable: true });

  /** Checked when sharing is allowed (`share_disabled` is false). */
  readonly videoSharingAllowedControl = new FormControl<boolean>(false, { nonNullable: true });

  constructor() {
    const svc = this.createSparkCampaignService;
    this.commentsAllowedControl.setValue(!svc.comment_disabled(), { emitEvent: false });
    this.commentsAllowedControl.valueChanges.pipe(takeUntilDestroyed()).subscribe((allowed) => {
      svc.comment_disabled.set(!allowed);
    });

    this.videoDownloadAllowedControl.setValue(!svc.video_download_disabled(), { emitEvent: false });
    this.videoDownloadAllowedControl.valueChanges.pipe(takeUntilDestroyed()).subscribe((allowed) => {
      svc.video_download_disabled.set(!allowed);
    });

    this.videoSharingAllowedControl.setValue(!svc.share_disabled(), { emitEvent: false });
    this.videoSharingAllowedControl.valueChanges.pipe(takeUntilDestroyed()).subscribe((allowed) => {
      svc.share_disabled.set(!allowed);
    });
  }
}
